module.exports = __webpack_public_path__ + "static/media/player-icon.000b043a.svg";